import React from 'react';
import PropTypes from 'prop-types';

export default class ScrollTransition extends React.Component {
  static propTypes = {
    onScroll: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      lastPosition: 0,
    };
    this.scrollTransition = this.scrollTransition.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.scrollTransition);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.scrollTransition);
  }

  scrollTransition() {
    const currentPosition = window.pageYOffset || document.documentElement.scrollTop;
    this.props.onScroll(currentPosition, this.state.lastPosition);
    this.setState({
      lastPosition: currentPosition <= 0 ? 0 : currentPosition,
    });
  }

  render() {
    return null;
  }
}
